<template>
  <section
    class="hero has-bg-img mb-20"
    :style="home ? 'min-height:575px' : ''"
  >
    <!-- Hero head: will stick at the top -->
    <div class="hero-head">
      <nav class="navbar is-fresh">
        <div class="container">
          <div class="navbar-brand">
            <router-link class="navbar-item" to="/">
              <img
                src="../assets/logo_takima_horizontal_inverted-1.png"
                alt=""
              />
            </router-link>
          </div>
          <!-- we toggle the menu if we click on the navbar-burger
          ref: https://bulma.io/documentation/components/navbar/#navbar-burger
          -->
          <div
            id="navbar-menu"
            class="navbar-menu is-static"
            :class="activeMenu ? 'is-active' : ''"
            @click="toggleActiveMenu"
          >
            <div class="navbar-end">
              <div class="navbar-item has-dropdown">
                <router-link class="navbar-link" to="/">
                  <b-icon icon="home" type="is-white" size="is-small"></b-icon>
                </router-link>
              </div>
              <div
                v-for="(activeApp, index) in activeApps"
                :key="index"
                class="navbar-item has-dropdown"
              >
                <router-link
                  v-if="authStore.isAuthenticated"
                  class="navbar-link"
                  :to="activeApp.userLink"
                >
                  {{ $t(activeApp.name) }}
                </router-link>
                <router-link
                  v-else
                  class="navbar-link"
                  :to="activeApp.publicLink"
                >
                  {{ $t(activeApp.name) }}
                </router-link>
              </div>
              <div class="navbar-item has-dropdown">
                <router-link class="navbar-link" to="/documentation">
                  {{ $t('layMainNavbar.documentation') }}
                </router-link>
              </div>
              <div
                v-if="activeSimulators.length > 0"
                class="navbar-item has-dropdown"
              >
                <a class="navbar-link">
                  {{ $t('layMainNavbar.simulators') }}
                </a>
                <div class="navbar-dropdown">
                  <router-link
                    v-for="(activeApp, index) in activeSimulators"
                    :key="index"
                    class="navbar-item"
                    :to="activeApp.publicLink"
                  >
                    {{ $t(activeApp.name) }}
                  </router-link>
                  <!-- <router-link class="navbar-item" to="/purchases-simulator">
                    {{ $t('purchases-simulator') }}
                  </router-link> -->
                </div>
              </div>
              <div class="logbox">
                <a v-if="!authStore.isAuthenticated" @click="displayUserMenu">
                  <b-icon icon="user-o"></b-icon>
                </a>
                <a v-else>
                  <b-icon icon="bars"></b-icon>
                </a>
                <div class="logbox-dropdown" v-if="authStore.isAuthenticated">
                  <b-icon icon="barrrs"></b-icon>
                  <ul>
                    <li v-if="authStore.isSuperUser">
                      <div class="logbox-ico">
                        <div class="logbox-label">
                          {{ $t('layMainNavbar.administration') }}
                        </div>
                        <router-link to="/administration/settings-editor">
                          <b-icon icon="cogs"></b-icon>
                        </router-link>
                      </div>
                    </li>
                    <li>
                      <div class="logbox-ico">
                        <div class="logbox-label">{{ $t(entityClass) }}</div>
                        <router-link to="/administration/my-entity">
                          <b-icon :icon="ICON"></b-icon>
                        </router-link>
                      </div>
                    </li>
                    <li v-for="(activeApp, index) in activeApps" :key="index">
                      <div class="logbox-ico">
                        <div class="logbox-label">{{ $t(activeApp.name) }}</div>
                        <router-link :to="activeApp.userLink">
                          <b-icon :icon="activeApp.icon"></b-icon>
                        </router-link>
                      </div>
                    </li>
                    <li>
                      <div class="logbox-ico">
                        <div class="logbox-label">
                          {{ $t('layMainNavbar.log-out') }}
                        </div>
                        <a @click="logOut" data-testId="log-out">
                          <b-icon icon="sign-out"></b-icon>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <b-modal :active.sync="isAuthModalOpen" width="500px">
                <auth-modal />
              </b-modal>
              <language-switcher class="navbar-item" />
            </div>
          </div>

          <!-- will be displayed only on small devices -->
          <a
            role="button"
            class="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            @click="toggleActiveMenu"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
      </nav>
    </div>
    <!-- Hero content: will be in the middle -->
    <div class="hero-body">
      <div v-if="home" class="container has-text-centered">
        <h1 class="main-title">
          {{ title }}
        </h1>
        <h2 class="main-subtitle">
          {{ subtitle }}
        </h2>
      </div>
    </div>
    <div style="display: flex; margin: auto; z-index: 10">
      <div v-if="!home" class="subpage-title1">
        <img class="subpage-img" src="../assets/logo_takima.png" />
      </div>
      <div v-if="!home" class="subpage-title2">
        <div class="subpage-title3">
          {{ title }}
        </div>
      </div>
    </div>
    <div style="margin-top: -35px">
      <svg
        class="waves"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shape-rendering="auto"
      >
        <defs>
          <path
            id="gentle-wave"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g>
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="0"
            fill="rgba(255,255,255,0.7"
          />
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="3"
            fill="rgba(255,255,255,0.5)"
          />
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="5"
            fill="rgba(255,255,255,0.3)"
          />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
      </svg>
    </div>
    <!--Waves end-->
  </section>
</template>

<script>
import { entityFactory } from '@/models/core'
import { useCoreStore } from '@/stores/core.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useScenarioStore } from '@/stores/scenario.js'

export default {
  name: 'MainNavbar',
  components: {
    'language-switcher': () => import('@/layout/LanguageSwitcher.vue'),
    'auth-modal': () => import('@/layout/AuthModal.vue')
  },
  data: function () {
    return {
      activeMenu: false
    }
  },
  setup () {
    const coreStore = useCoreStore()
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    const scenarioStore = useScenarioStore()
    return { coreStore, authStore, ghgiStore, scenarioStore }
  },
  computed: {
    entityClass: function () {
      return this.coreStore.entityClass
    },
    activeApps: function () {
      return this.coreStore.activeApps
    },
    activeSimulators: function () {
      return this.coreStore.activeSimulators
    },
    ICON: function () {
      const EntityClass = entityFactory(this.entityClass)
      return EntityClass.ICON
    },
    isAuthModalOpen: {
      get: function () {
        return this.authStore.isAuthModalOpen
      },
      set: function (value) {
        this.authStore.closeAuthModal()
      }
    },
    title: function () {
      let title = null
      if (this.$i18n.locale === 'en' && this.$route.meta.titleen) {
        title = this.$route.meta.titleen
      } else {
        title = this.$route.meta.titlefr
      }
      if (this.$route.name === 'ges-1point5-id' && this.ghgiStore.item.year) {
        title += ' - ' + this.$t('ghgi') + ' ' + this.ghgiStore.item.year
      } else if (
        this.$route.name === 'ges-1point5-results' &&
        this.ghgiStore.item.year
      ) {
        title += ' - ' + this.$t('ghgi') + ' ' + this.ghgiStore.item.year
      } else if (
        this.$route.name === 'scenario-1point5-uuid' &&
        this.scenarioStore.item.name
      ) {
        title += ' - ' + this.scenarioStore.item.name
        title += ' (' + this.scenarioStore.item.timeline + ')'
      }
      return title
    },
    subtitle: function () {
      if (this.$i18n.locale === 'en' && this.$route.meta.titleen) {
        return this.$route.meta.subtitleen
      } else {
        return this.$route.meta.subtitlefr
      }
    },
    home: function () {
      if (this.$route.meta.home) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    toggleActiveMenu () {
      this.activeMenu = !this.activeMenu
    },
    displayUserMenu () {
      if (!this.authStore.isAuthenticated) {
        this.authStore.openAuthModal('/administration/all-ghgi')
      }
    },
    logOut () {
      this.authStore.authLogout().then(() => {
        this.$router.push('/').catch(() => {})
      })
    }
  },
  mounted () {
    if (this.authStore.isAuthenticated) {
      this.authStore.checkIsSuperUser()
    }
  }
}
</script>

<style scoped>
.navbar-link.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.logbox-ico.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
